package co.maytes.standupbot.dashboard.pages.app.templates

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.layout.AdminGuard
import co.maytes.standupbot.dashboard.components.layout.AppShell
import co.maytes.standupbot.dashboard.components.layout.AuthGuard
import co.maytes.standupbot.dashboard.components.widgets.AppPageHeader
import co.maytes.standupbot.dashboard.features.templates.TemplateEditor
import co.maytes.standupbot.dashboard.features.templates.TemplateEditorMode
import co.maytes.standupbot.dashboard.features.templates.rememberTemplatesStore
import co.maytes.standupbot.dashboard.stores.rememberAuthStore
import co.maytes.standupbot.dashboard.styles.Spacing
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.css.px

@Page("/app/templates/{templateId}")
@Composable
fun TemplatesDynamicPage() {
    AuthGuard {
        AdminGuard {
            AppShell {
                TemplatesDynamicContent()
            }
        }
    }
}

@Composable
private fun TemplatesDynamicContent() {
    val auth = rememberAuthStore()
    val ctx = rememberPageContext()
    val store = rememberTemplatesStore()
    val workspaceId = auth.currentUser?.workspace?.id ?: return
    val templateId = ctx.route.params["templateId"] ?: return

    Box(
        modifier = Modifier.fillMaxWidth()
            .styleModifier { property("margin", "0 auto") }
            .maxWidth(1200.px),
    ) {
        Column(modifier = Modifier.fillMaxWidth()) {
            AppPageHeader(
                title = "Edit template",
                eyebrow = "admin",
                subtitle = "Sections and headings apply to your posted standup. The prompt text is a preview only for now.",
            )
            Box(modifier = Modifier.margin(top = Spacing.md)) {
                TemplateEditor(
                    workspaceId = workspaceId,
                    mode = TemplateEditorMode.Edit(templateId = templateId),
                    store = store,
                )
            }
        }
    }
}
